export default __webpack_public_path__ + "static/media/couch.cd1673aa.png";